module.exports = __webpack_public_path__ + "img/NAR-1.c2686f3f.png";